import intl from "react-intl-universal";
import { CheckCircle } from "components/icons/check-circle.icon";
import { IconAlert } from "components/icons/icn-alert.icon";
import IconStop from "components/icons/stop.icon";
import { ListOfOrderStatusAbleToBeAccepted, ListOfOrderStatusAbleToBeRefused, StatusPedido } from "models/pedidos/statusPedido";
import Session from "utils/user-storage";
import { IOrder } from "types/orders/order";
import TipoUsuario from "models/usuarios/tipo-usuario";
import TipoPerfilAcesso from "models/usuarios/tipo-perfil-acesso";

export const getButtonIcon = (type: string) => {
  switch (type) {
    case "accept":
      return <CheckCircle />;
    case "refuse":
      return <IconStop />;
    default:
      return <IconAlert />;
  }
};

export const getButtonTextContent = (type: string) => {
  switch (type) {
    case "accept":
      return {
        buttonText: intl.get("commons.accept"),
        modalConfirmationTitle: intl.get("requestOrders.acceptOrders"),
        modalConfirmationMessage: intl.get("orderPlanning.messageModalConfirmation")
      };
    case "refuse":
      return {
        buttonText: intl.get("commons.refuse"),
        modalConfirmationTitle: intl.get("orders.refuseOrders"),
        modalConfirmationMessage: intl.get("orders.refuseOrdersConfimationQuestion")
      };
    default:
      return { buttonText: "", modalConfirmationTitle: "", modalConfirmationMessage: "" };
  }
};

export const getAlterableItems = (actionType: string, items: IOrder[]) => {
  const userData =  Session.get()
  const userType = userData.TipoUsuario ?? 0;
  const userTypeAccessLevel = userData.PerfilAcesso;
  return (
    actionType == "accept" ? getAcceptableItems(items, userType, userTypeAccessLevel) : getRefusableItems(items, userType, userTypeAccessLevel)
  );
};

const getAcceptableItems = (items: IOrder[], userType: number, profileAccessLevel: number) => {
  return items.filter(
    (item: IOrder) => (
      (ListOfOrderStatusAbleToBeAccepted.includes(item.OrderStatus as (typeof ListOfOrderStatusAbleToBeAccepted)[number]) 
        && item.NextStepUserType == userType) ||
      (item.OrderStatus == StatusPedido.EmCancelamento &&
        item.NextStepUserType == userType &&
        TipoUsuario.Fornecedor == userType) || ((item.OrderStatus == StatusPedido.AguardandoAprovacaoGestor) && (TipoPerfilAcesso.Administrador == profileAccessLevel || TipoPerfilAcesso.Gestor == profileAccessLevel))
      )
  );
};

const getRefusableItems = (items: IOrder[], userType: number, profileAccessLevel: number) => {
  return items.filter((item: IOrder) => (
    (ListOfOrderStatusAbleToBeRefused.includes(item.OrderStatus as typeof ListOfOrderStatusAbleToBeRefused[number]) 
      && item.NextStepUserType == userType) ||
    (item.OrderStatus == StatusPedido.EmCancelamento &&
      item.NextStepUserType == userType &&
      TipoUsuario.Fornecedor == userType) || ((item.OrderStatus == StatusPedido.AguardandoAprovacaoGestor) && (TipoPerfilAcesso.Administrador == profileAccessLevel || TipoPerfilAcesso.Gestor == profileAccessLevel))
  ));
};